import React from "react";

const EditChapter = () => <div></div>;

export default EditChapter;
